export const GAME_TITLE = "Jennections";
export const MAX_MISTAKES = 4;
